import React from 'react';
import { path } from 'ramda';

import { notEmpty } from 'utils/ramdaAdditions';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import { DefinitionField } from 'components/common/fields/DefinitionField';
import { DateField } from 'components/common/fields/DateTimeFields';

const ActionDescriptionField = ({ descriptions }) => notEmpty(descriptions) ? (
    <div className="action-description">
        { descriptions.map((description, index) => notEmpty(description) && (
            <div key={index}>
                <DefinitionHeader translate="education.action.headers.project" iconType='vacancy' />
                <div className="panel-view">
                    <DefinitionField
                        translate="education.actionVacancy.card.annotation"
                        text={description.annotation}
                    />
                    <DefinitionField
                        translate="education.actionVacancy.card.authors"
                        text={description.authors}
                    />
                    <DefinitionField
                        translate="common.comment"
                        text={description.comment}
                    />
                    <DefinitionField
                        translate="education.actionVacancy.card.date"
                        show={description.date}
                    >
                        <DateField date={description.date} />
                    </DefinitionField>
                    <DefinitionField
                        translate="education.actionVacancy.card.duration"
                        text={description.duration}
                    />
                    <DefinitionField
                        translate="education.actionVacancy.card.exam"
                        text={description.exam}
                    />
                    <DefinitionField
                        translate="education.actionVacancy.card.requirments"
                        text={description.requirments}
                    />
                    <DefinitionField translate="education.actionVacancy.card.cost" show={description.cost}>
                        <span>
                            {description.cost} {path(['name'], description.costValuta)}
                        </span>
                    </DefinitionField>
                    <DefinitionField translate="education.actionVacancy.card.costPerPeople" show={description.costPerPeople}>
                        <span>
                            {description.costPerPeople} {path(['name'], description.costValuta)}
                        </span>
                    </DefinitionField>
                    <DefinitionField
                        translate="education.actionVacancy.card.goals"
                        text={description.goals}
                    />
                    <DefinitionField
                        translate="education.actionVacancy.card.tasks"
                        text={description.tasks}
                    />
                    <DefinitionField
                        translate="education.actionVacancy.card.additionalResources"
                        text={description.additionalResources}
                    />
                    <DefinitionField
                        translate="education.actionVacancy.card.schedule"
                        text={description.schedule}
                    />
                    <DefinitionField
                        translate="education.actionVacancy.card.trainer"
                        text={description.trainer}
                    />
                </div>
            </div>
        ))}
    </div>
) : null;

export default ActionDescriptionField;
